module.exports = require('./dist/core');



// WEBPACK FOOTER //
// ./node_modules/leancloud-realtime/core.js